import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { EmployeeCompanyFormBuilder, EmployeeCompany } from '../../models/EmployeeCompany';
import { EmployeeService } from '../../service/employee.service';

@Component({
  selector: 'app-employee-company-manage',
  templateUrl: './employee-company-manage.component.html',
  styleUrls: ['./employee-company-manage.component.scss']
})
export class EmployeeCompanyManageComponent  {
  
  constructor(private activatedRoute:ActivatedRoute, 
    private employeeService: EmployeeService,
    private fb: UntypedFormBuilder, 
    private formUtilsService: FormUtilsService, public uiNotification: UiNotificationService) { 
      this.editDataForm = EmployeeCompanyFormBuilder.getForm(this.fb, EmployeeCompanyFormBuilder.initEmployeeCompany() );
      this.loadData();
    }

  employeeCompany: EmployeeCompany;
  editDataForm: UntypedFormGroup;
  
  

  loadData() {
    this.employeeService.getEmployeeCompany(this.activatedRoute.snapshot.params.id).subscribe(
      data => {
      this.employeeCompany = data;
      this.editDataForm = EmployeeCompanyFormBuilder.getForm(this.fb, this.employeeCompany ); 
    });
  }

  update() {

    if(!this.formUtilsService.markFormGroupTouched(this.editDataForm)){
      this.uiNotification.showValidationError();
      return;
    }
    
    Object.assign(this.employeeCompany, this.editDataForm.value);

      this.employeeService.storeEmployeeCompany(this.employeeCompany).subscribe(
        () => {   this.uiNotification.showSuccess('validations.dataUpdatedSuccesfully');
        this.loadData(); });
  }
}

